var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNdCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 14,
      height: 14,
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8001 2.0001C6.13736 2.0001 5.6001 2.53736 5.6001 3.2001V4.4001H4.4001C3.07461 4.4001 2.0001 5.47461 2.0001 6.8001V18.8001C2.0001 20.1256 3.07461 21.2001 4.4001 21.2001H18.8001C20.1256 21.2001 21.2001 20.1256 21.2001 18.8001V6.8001C21.2001 5.47461 20.1256 4.4001 18.8001 4.4001H17.6001V3.2001C17.6001 2.53736 17.0628 2.0001 16.4001 2.0001C15.7374 2.0001 15.2001 2.53736 15.2001 3.2001V4.4001H8.0001V3.2001C8.0001 2.53736 7.46284 2.0001 6.8001 2.0001ZM6.8001 8.0001C6.13736 8.0001 5.6001 8.53736 5.6001 9.2001C5.6001 9.86284 6.13736 10.4001 6.8001 10.4001H16.4001C17.0628 10.4001 17.6001 9.86284 17.6001 9.2001C17.6001 8.53736 17.0628 8.0001 16.4001 8.0001H6.8001Z",
    fill: "#E3B53A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdCalendar);
export default __webpack_public_path__ + "static/media/nd-calendar.64ffc939f5ba28a09cce79cd72980c4f.svg";
export { ForwardRef as ReactComponent };